"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var getAddonWithType = function getAddonWithType(addonType, addon) {
  return _defineProperty({}, addonType, addon);
};
var extractCommonAddon = function extractCommonAddon(addonType, addon) {
  return [getAddonWithType(addonType, addon)];
};
var extractComplexAddon = function extractComplexAddon(addonType, addons) {
  return addons.reduce(function (acc, addon) {
    return [].concat(_toConsumableArray(acc), [getAddonWithType(addonType, addon)]);
  }, []);
};
var extractBurnInAddon = function extractBurnInAddon(addon) {
  if (Array.isArray(addon)) {
    return extractComplexAddon('BURN_IN_CAPTIONS', addon);
  }
  return extractCommonAddon('BURN_IN_CAPTIONS', addon);
};
var extractDurationAddon = function extractDurationAddon(addon) {
  if (addon.value === 'STANDARD') {
    return [];
  }
  return extractCommonAddon('DURATION', addon);
};
var getAddons = function getAddons(addonType, addon) {
  if (!addon) {
    return [];
  }
  switch (addonType) {
    case 'VOICE_OVER_ARTISTS':
    case 'SRT_CAPTIONS':
    case 'SUPERSIZE_MY_EDIT':
      {
        var complexAddon = addon;
        return extractComplexAddon(addonType, complexAddon);
      }
    case 'BURN_IN_CAPTIONS':
      {
        return extractBurnInAddon(addon);
      }
    case 'DURATION':
      {
        return extractDurationAddon(addon);
      }
    default:
      {
        var commonAddon = addon;
        return extractCommonAddon(addonType, commonAddon);
      }
  }
};
var getAddonsList = function getAddonsList(addons) {
  if (!addons) {
    return [];
  }
  var addonsEntries = Object.entries(addons);
  if (!addonsEntries) {
    return [];
  }
  return addonsEntries.reduce(function (acc, _ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      addonType = _ref3[0],
      addon = _ref3[1];
    return [].concat(_toConsumableArray(acc), _toConsumableArray(getAddons(addonType, addon)));
  }, []);
};
var _default = getAddonsList;
exports["default"] = _default;